import { tracking } from '@iwoca/frontend-tracking-library';
import { IconPhoneFilled } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export const NeedHelpSection = ({ theme }: { theme: 'light' | 'dark' }) => {
    const textColor =
        theme === 'dark' ? 'text-structure-100' : 'text-primary-10';
    const borderColor =
        theme === 'dark' ? 'border-secondary-20' : 'border-structure-80';

    return (
        <div className={`border-t ${borderColor} pt-xl`}>
            <Text className={`font-bold ${textColor}`}>
                <FormattedMessage
                    id="_.loan_summary.need_help"
                    defaultMessage="Need some help?"
                />
            </Text>
            <div className="flex items-center gap-m pb-xl pt-s">
                <IconPhoneFilled fontSize="24px" />
                <div>
                    <Text className={`font-bold ${textColor}`}>
                        <FormattedMessage
                            id="_.loan_summary.phone_number"
                            defaultMessage="020 3778 0105"
                        />
                    </Text>
                    <Text className={`font-reg ${textColor}`}>
                        <FormattedMessage
                            id="_.loan_summary.phone_hours"
                            defaultMessage="Monday to Friday (9am - 6pm)"
                        />
                    </Text>
                </div>
            </div>
            <Text className={`text-s ${textColor}`}>
                <FormattedMessage
                    id="_.loan_summary.upload_docs_prompt"
                    defaultMessage="Been asked to upload additional docs? {link}"
                    values={{
                        link: (
                            <Link
                                to={maintainStateKey({
                                    pathname: '/trading'
                                })}
                                className="font-bold underline"
                                onClick={() =>
                                    tracking.ampli.uploadDocumentsCtaClicked({
                                        suggested_product_status: 'approved'
                                    })
                                }
                            >
                                <FormattedMessage
                                    id="_.loan_summary.upload_docs_link"
                                    defaultMessage="Upload docs"
                                />
                            </Link>
                        )
                    }}
                />
            </Text>
        </div>
    );
};
